<template>
  <div>
    <v-row class="mt-3">
      <v-col class="" cols="auto">
        <div class="tertiary--text text-body-2">
          {{
            $t('fleet_management.persons.person_info.labels.card_field_name')
          }}
        </div>
        <div class="readonly">
          <span class="value secondary--text">{{
            personInfo.personFirstName
          }}</span>
        </div>
      </v-col>
      <v-col cols="auto">
        <div class="tertiary--text text-body-2">
          {{
            $t(
              'fleet_management.persons.person_info.labels.card_field_lastname'
            )
          }}
        </div>
        <div class="readonly">
          <span class="readonly value secondary--text">{{
            personInfo.personLastName
          }}</span>
        </div>
      </v-col>
      <v-col cols="auto">
        <div class="tertiary--text text-body-2">
          {{
            $t('fleet_management.persons.person_info.labels.card_field_mail')
          }}
        </div>
        <div class="readonly">
          <span
            class="value secondary--text d-flex flex-column"
            :key="index"
            v-for="(email, index) in personInfo.person.emails"
          >
            {{ email.email }}</span
          >
        </div>
      </v-col>
    </v-row>
    <v-row class="mb-3">
      <v-col v-if="personInfo.personIdentificationType" cols="12" sm="12" md="4" lg="3" xl="2">
        <div class="tertiary--text text-body-2">
          {{
            $t(
              'fleet_management.persons.person_info.labels.card_field_identification_type'
            )
          }}
        </div>
        <div class="readonly">
          <span class="value secondary--text">{{
            personInfo.personIdentificationType
          }}</span>
        </div>
      </v-col>
      <v-col v-if="numberId" cols="12" sm="12" md="4" lg="3" xl="2">
        <div class="tertiary--text text-body-2">
          {{
            $t('fleet_management.persons.person_info.labels.card_field_number')
          }}
        </div>
        <div class="readonly">
          <span class="value secondary--text" id="idNumber">{{
            numberId
          }}</span>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'PersonalData',
  props: {
    personInfo: {
      type: Object,
      default() {
        return {
          personFirstName: '',
          personLastName: '',
          person: {},
          personIdentificationType: '',
          personIdentificationNumber: ''
        }
      }
    }
  },
  computed: {
    personIdentificationNumber() {
      return this.personInfo.personIdentificationNumber
    },
    numberId: {
      get() {
        return this.formatDocument(this.personInfo.personIdentificationNumber)
      },
      set(value) {
        this.personInfo.personIdentificationNumber = value
      }
    }
  },
  methods: {
    formatDocument(number) {
      const idType = this.personInfo.personIdentificationType
      if (idType === 'RUT' || idType === 'CI') {
        const numberDocWithOutDash = number.replace('-', '')
        const digits = numberDocWithOutDash.split('')
        const checkDigit = digits.splice(-1)
        const docFormatted = []

        while (digits.length > 0) {
          const group = digits.splice(-3)
          docFormatted.unshift(group.join(''))
        }

        return `${docFormatted.join('.')}-${checkDigit.join('')}`
      } else if (idType === 'DNI') {
        return number.replace(/^(\d{2})(\d{3})(\d{3})$/, '$1.$2.$3')
      }
    }
  }
}
</script>

<style scoped></style>
